import { z } from 'zod';
import { Result } from 'libs/end-to-end/src/result';
import { errResult } from 'libs/end-to-end/src/result';
import { okResult } from 'libs/end-to-end/src/result';
import { BaseError } from 'libs/end-to-end/src/types/errors/base-error';

export const deserializeError = (
  rawResponse: unknown,
): Result<BaseError, BaseError> => {
  if (typeof rawResponse !== 'object' || rawResponse === null) {
    return errResult({
      errorType: 'UnknownError',
      errorReason: 'Raw response is not an object',
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
  const rawResponseAny = rawResponse as any;

  const parseResult = BaseError.safeParse(rawResponseAny);

  if (parseResult.success) {
    return okResult(parseResult.data);
  }

  return errResult({
    errorType: 'UnknownError',
    errorReason: `Unable to parse error because: ${parseResult.error.message}`,
  });
};

export const ApiResponseCode = z
  .enum([
    'Ok',
    'BadRequest',
    'InternalServerError',
    'Unauthorized',
    'NotFound',
    'Forbidden',
    'Conflict',
    'ServiceUnavailable',
  ])
  .describe('ApiResponseCode');

export type ApiResponseCode = z.infer<typeof ApiResponseCode>;
